/* eslint-disable no-constant-condition */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";

// core components
import styles from "assets/jss/material-dashboard-react/components/tableStyle.js";
import { blue, red } from "@material-ui/core/colors";

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(theme => ({
  tableCell: {
    "&:hover": {
      backgroundColor: "tomato !important"
    },
    padding: "12px 8px",
    textAlign: "center"
  }
}));

const useStyles3 = makeStyles(theme => ({
  tableCell: {
    "&:hover": {
      backgroundColor: "green !important"
    },
    padding: "12px 8px",
    textAlign: "center"
  }
}));

export default function CustomTable(props) {
  const classes = useStyles();
  const classes2 = useStyles2();
  const classes3 = useStyles3();
  const { tableHead, tableData, tableHeaderColor } = props;

  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow className={classes.tableHeadRow}>
              {tableHead.map((prop, key) => {
                return (
                  <TableCell
                    style={{ textAlign: "center" }}
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                  >
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {tableData.slice().map((prop, key1) => {
            return (
              <TableRow
                key={key1}
                className={classes.tableBodyRow}
                style={{ cursor: "pointer" }}
                selected={true}
                hover={true}
                role="checkbox"
              >
                {prop.slice(0, 1).map((prop, key) => {
                  return (
                    <TableCell
                      className={classes.tableCell}
                      key={key}
                      style={{ textAlign: "center" }}
                    >
                      <h6>{prop}</h6>
                    </TableCell>
                  );
                })}
                {prop.slice(1, 2).map((prop, key) => {
                  return (
                    <TableCell
                      className={classes.tableCell}
                      key={key}
                      style={{ textAlign: "center" }}
                    >
                      <h6>{prop.Value}</h6>
                    </TableCell>
                  );
                })}
                {tableData[0][2] !== undefined
                  ? prop.slice(2, 3).map((prop, key) => {
                      return (
                        <TableCell
                          className={
                            prop.Flag ? classes3.tableCell : classes2.tableCell
                          }
                          classes={{
                            hover: prop.Flag ? classes3.hover : classes2.hover
                          }}
                          key={key}
                          style={{
                            backgroundColor: prop.Flag
                              ? "MediumSeaGreen"
                              : "Orange",
                            textAlign: "center"
                          }}
                        >
                          <h6>{prop.Value}</h6>
                        </TableCell>
                      );
                    })
                  : console.log("")}
                {tableData[0][3] !== undefined
                  ? prop.slice(3, 4).map((prop, key) => {
                      return (
                        <TableCell
                          className={
                            prop.Flag ? classes3.tableCell : classes2.tableCell
                          }
                          classes={{
                            hover: prop.Flag ? classes3.hover : classes2.hover
                          }}
                          key={key}
                          style={{
                            backgroundColor: prop.Flag
                              ? "MediumSeaGreen"
                              : "Orange",
                            textAlign: "center"
                          }}
                        >
                          <h6>{prop.Value}</h6>
                        </TableCell>
                      );
                    })
                  : console.log("")}
                {tableData[0][4] !== undefined
                  ? prop.slice(4, 5).map((prop, key) => {
                      return (
                        <TableCell
                          className={
                            prop.Flag ? classes3.tableCell : classes2.tableCell
                          }
                          classes={{
                            hover: prop.Flag ? classes3.hover : classes2.hover
                          }}
                          key={key}
                          style={{
                            backgroundColor: prop.Flag
                              ? "MediumSeaGreen"
                              : "Orange",
                            textAlign: "center"
                          }}
                        >
                          <h6>{prop.Value}</h6>
                        </TableCell>
                      );
                    })
                  : console.log("")}
                {tableData[0][5] !== undefined
                  ? prop.slice(5, 6).map((prop, key) => {
                      return (
                        <TableCell
                          className={
                            prop.Flag ? classes3.tableCell : classes2.tableCell
                          }
                          classes={{
                            hover: prop.Flag ? classes3.hover : classes2.hover
                          }}
                          key={key}
                          style={{
                            backgroundColor: prop.Flag
                              ? "MediumSeaGreen"
                              : "Orange",
                            textAlign: "center"
                          }}
                        >
                          <h6>{prop.Value}</h6>
                        </TableCell>
                      );
                    })
                  : console.log("")}
                {tableData[0][6] !== undefined
                  ? prop.slice(6, 7).map((prop, key) => {
                      return (
                        <TableCell
                          className={
                            prop.Flag ? classes3.tableCell : classes2.tableCell
                          }
                          classes={{
                            hover: prop.Flag ? classes3.hover : classes2.hover
                          }}
                          key={key}
                          style={{
                            backgroundColor: prop.Flag
                              ? "MediumSeaGreen"
                              : "Orange",
                            textAlign: "center"
                          }}
                        >
                          <h6>{prop.Value}</h6>
                        </TableCell>
                      );
                    })
                  : console.log("")}
                {tableData[0][7] !== undefined
                  ? prop.slice(7, 8).map((prop, key) => {
                      return (
                        <TableCell
                          className={
                            prop.Flag ? classes3.tableCell : classes2.tableCell
                          }
                          classes={{
                            hover: prop.Flag ? classes3.hover : classes2.hover
                          }}
                          key={key}
                          style={{
                            backgroundColor: prop.Flag
                              ? "MediumSeaGreen"
                              : "Orange",
                            textAlign: "center"
                          }}
                        >
                          <h6>{prop.Value}</h6>
                        </TableCell>
                      );
                    })
                  : console.log("")}
                {tableData[0][8] !== undefined
                  ? prop.slice(8, 9).map((prop, key) => {
                      return (
                        <TableCell
                          className={
                            prop.Flag ? classes3.tableCell : classes2.tableCell
                          }
                          classes={{
                            hover: prop.Flag ? classes3.hover : classes2.hover
                          }}
                          key={key}
                          style={{
                            backgroundColor: prop.Flag
                              ? "MediumSeaGreen"
                              : "Orange",
                            textAlign: "center"
                          }}
                        >
                          <h6>{prop.Value}</h6>
                        </TableCell>
                      );
                    })
                  : console.log("")}
                {tableData[0][9] !== undefined
                  ? prop.slice(9, 10).map((prop, key) => {
                      return (
                        <TableCell
                          className={
                            prop.Flag ? classes3.tableCell : classes2.tableCell
                          }
                          classes={{
                            hover: prop.Flag ? classes3.hover : classes2.hover
                          }}
                          key={key}
                          style={{
                            backgroundColor: prop.Flag
                              ? "MediumSeaGreen"
                              : "Orange",
                            textAlign: "center"
                          }}
                        >
                          <h6>{prop.Value}</h6>
                        </TableCell>
                      );
                    })
                  : console.log("")}
                {tableData[0][10] !== undefined
                  ? prop.slice(10, 11).map((prop, key) => {
                      return (
                        <TableCell
                          className={
                            prop.Flag ? classes3.tableCell : classes2.tableCell
                          }
                          classes={{
                            hover: prop.Flag ? classes3.hover : classes2.hover
                          }}
                          key={key}
                          style={{
                            backgroundColor: prop.Flag
                              ? "MediumSeaGreen"
                              : "Orange",
                            textAlign: "center"
                          }}
                        >
                          <h6>{prop.Value}</h6>
                        </TableCell>
                      );
                    })
                  : console.log("")}
                {tableData[0][11] !== undefined
                  ? prop.slice(11, 12).map((prop, key) => {
                      return (
                        <TableCell
                          className={
                            prop.Flag ? classes3.tableCell : classes2.tableCell
                          }
                          classes={{
                            hover: prop.Flag ? classes3.hover : classes2.hover
                          }}
                          key={key}
                          style={{
                            backgroundColor: prop.Flag
                              ? "MediumSeaGreen"
                              : "Orange",
                            textAlign: "center"
                          }}
                        >
                          <h6>{prop.Value}</h6>
                        </TableCell>
                      );
                    })
                  : console.log("")}
                {tableData[0][12] !== undefined
                  ? prop.slice(12, 13).map((prop, key) => {
                      return (
                        <TableCell
                          className={
                            prop.Flag ? classes3.tableCell : classes2.tableCell
                          }
                          classes={{
                            hover: prop.Flag ? classes3.hover : classes2.hover
                          }}
                          key={key}
                          style={{
                            backgroundColor: prop.Flag
                              ? "MediumSeaGreen"
                              : "Orange",
                            textAlign: "center"
                          }}
                        >
                          <h6>{prop.Value}</h6>
                        </TableCell>
                      );
                    })
                  : console.log("")}
                {tableData[0][13] !== undefined
                  ? prop.slice(13, 14).map((prop, key) => {
                      return (
                        <TableCell
                          className={
                            prop.Flag ? classes3.tableCell : classes2.tableCell
                          }
                          classes={{
                            hover: prop.Flag ? classes3.hover : classes2.hover
                          }}
                          key={key}
                          style={{
                            backgroundColor: prop.Flag
                              ? "MediumSeaGreen"
                              : "Orange",
                            textAlign: "center"
                          }}
                        >
                          <h6>{prop.Value}</h6>
                        </TableCell>
                      );
                    })
                  : console.log("")}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray"
};

CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
  // tableSelect: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
